var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14570_92583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.35352 10.2886L9.11788 12.053L13.0877 8.08316M17.0575 10.7297C17.0575 15.0598 12.3343 18.2091 10.6158 19.2117C10.4205 19.3257 10.3228 19.3826 10.185 19.4122C10.0781 19.4351 9.92203 19.4351 9.81508 19.4122C9.67726 19.3826 9.57961 19.3257 9.3843 19.2117C7.66578 18.2091 2.94263 15.0598 2.94263 10.7297V6.51076C2.94263 5.80545 2.94263 5.45279 3.05798 5.14965C3.15989 4.88185 3.32548 4.6429 3.54044 4.45346C3.78378 4.23901 4.11398 4.11518 4.77439 3.86753L9.50445 2.09376C9.68785 2.02498 9.77955 1.9906 9.87389 1.97696C9.95756 1.96487 10.0425 1.96487 10.1262 1.97696C10.2206 1.9906 10.3123 2.02498 10.4957 2.09376L15.2257 3.86753C15.8861 4.11518 16.2163 4.23901 16.4597 4.45346C16.6746 4.6429 16.8402 4.88185 16.9421 5.14965C17.0575 5.45279 17.0575 5.80545 17.0575 6.51076V10.7297Z",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14570_92583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.728027)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.73f13a929317317349bb5094fd03231f.svg";
export { ForwardRef as ReactComponent };